import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import { FontWeight, PRESSABLE, ZIndex } from '../../../styles/constants';
import { prop } from '../../../util/prop';
import { CTADot } from '../../CTADot';

export const UserAvatarView = styled.div`
  margin: 0 0 0 12px;
  position: relative;
  width: 44px;
`;

export const AvatarInner = styled.div.attrs({ title: 'Avatar' })`
  ${PRESSABLE};
  align-items: center;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  height: 44px;
  justify-content: center;
  overflow: hidden;
  width: 44px;
`;

export const Image = styled.div<{ src: string }>`
  background-image: url('${prop('src')}');
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-block;
  height: 100%;
  width: 100%;
`;

export const Sentinel = styled.img`
  height: 100%;
  opacity: 0.01;
  pointer-events: none;
  position: absolute;
  width: 100%;
`;

export const Initials = styled.div`
  align-items: center;
  background-color: ${ThemeColours.buttonPrimaryFill};
  color: ${ThemeColours.buttonPrimaryText};
  display: flex;
  font-size: 16px;
  font-weight: ${FontWeight.BOLD};
  height: 100%;
  justify-content: center;
  text-transform: uppercase;
  width: 100%;
`;

export const AvatarDot = styled(CTADot)`
  position: absolute;
  right: 1px;
  top: 1px;
  z-index: ${ZIndex.OVERLAY};
`;
